import React from "react";
import WideSecureLayout from "../../../layout/WideSecureLayout.jsx";

export default function PowerBiDashboard({project}) {
    return <WideSecureLayout title="Power BI">
        <iframe className={'powerbi'} title="Datixo" width="1024" height="1060" src="https://app.powerbi.com/view?r=eyJrIjoiY2NkZmI3YTUtMDU1Yi00MGJhLWE5NjMtNDE2ZjRmMWUzZDk1IiwidCI6ImIwN2NlNjEwLWZmYTktNGM4YS05MjU5LTJiOTkzOTNlMzliMiIsImMiOjl9" frameBorder="0" allowFullScreen={true}></iframe>
    </WideSecureLayout>
}
